import { render, staticRenderFns } from "./ShowEntityRequestModal.vue?vue&type=template&id=2c132468"
import script from "./ShowEntityRequestModal.vue?vue&type=script&lang=js"
export * from "./ShowEntityRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports